import { memo } from "react";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { FormFieldProps } from "./types";
import { Separator } from "@/components/ui/separator";
import { useTranslation } from "react-i18next";

const CheckboxField = memo(({ config, control }: FormFieldProps) => {
  const { t } = useTranslation();
  return (
    <>
      <FormField
        control={control}
        name={config.name}
        render={({ field }) => (
          <FormItem className={config.className}>
            <FormControl>
              <div className="items-center flex gap-1">
                <Checkbox
                  id={field.name}
                  {...field}
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
                <Label
                  htmlFor={field.name}
                  className="text-slate-700 text-sm font-medium font-['Raleway'] leading-normal"
                >
                  {t(config.label ?? "")}
                </Label>
              </div>
            </FormControl>
          </FormItem>
        )}
      />
      {config.separator && <Separator className="my-4" />}
    </>
  );
});

CheckboxField.displayName = "CheckboxField";
export default CheckboxField;
